import {HttpStatus} from '../constants/httpStatus';
import {
  PLAID_EVENT_VIEW_NAME_FOOTER,
  STATUS_PROCESS_OBV_VERIFICATION_SUCCESS
} from '../constants/status';
import {parseURL} from "./convertParams.js";
import {getTraceParent} from "./sessionStorage.js";

// Plaid Link names its iframe plaid-link-iframe-<suffix>. The suffix was a counter ("1") up to
// SDK 2.0.2845 and is a uuid since 2.0.2846, so the iframe is looked up by prefix, never by id.
export const PLAID_FRAME_ID_PREFIX = 'plaid-link-iframe-';
export const DEFAULT_PLAID_FRAME_CLASS = 'plaid-frame';
export const RESIZE_PLAID_FRAME_CLASS = 'plaid-frame-resize';
export const RESIZE_MOBILE_PLAID_FRAME_CLASS = 'plaid-frame-resize-mobile';
export const MOBILE = 'mobile';
export const DESKTOP = 'desktop';
import { plaidNuveiLogoMap } from 'react-components-core';

export const decodeURL = (value) => {
  return decodeURIComponent(value.replace(/\+/g,  " "))
}

export const isSuccessStatus = (status) => {
  return [HttpStatus.SUCCESS, HttpStatus.CREATED_SUCCESS].includes(status);
};

export const isVerifiedSuccessfully = (status) => {
  return STATUS_PROCESS_OBV_VERIFICATION_SUCCESS.includes(status);
}

export const getResponsiveHeaderValueByKey = (response, key) => {
  return response.headers[key]
}

export const isMobileDevice = () => {
  let check = false;
  /* eslint-disable */
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

export const getPlaidFrame = () => {
  return window.document.querySelector(`iframe[id^="${PLAID_FRAME_ID_PREFIX}"]`);
}

export const isPlaidExist = () => {
  return !!getPlaidFrame();
}

export const isPlaidSDKShowing = () => {
  const plaidDom = getPlaidFrame();
  return plaidDom && JSON.stringify(plaidDom.getAttribute("style")).includes('display: block')
}

export const setPlaidFrameZIndex = () => {
  const plaidDom = getPlaidFrame();
  if (plaidDom) plaidDom.style.zIndex = 2147483626;
}

export const isInFrame = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export const sendRedirectUri = (obvInfo) => {
  if (obvInfo.properties) {
    return isInFrame() ? obvInfo.properties.isRedirectURIIframe :
        obvInfo.properties.isRedirectURINewWindow;
  }

  return isInFrame();
}

export const isPlaidFooterShown = (metaView) => {
  return PLAID_EVENT_VIEW_NAME_FOOTER.includes(metaView);
}

export const setPlaidIframeResize = () => {
  const plaidDom = getPlaidFrame();
  if (!plaidDom) return;
  plaidDom.classList.remove(DEFAULT_PLAID_FRAME_CLASS);
  if (navigator.userAgent.match(/(iPhone)/g) != null) {
    plaidDom.classList.add(RESIZE_MOBILE_PLAID_FRAME_CLASS);
  } else {
    plaidDom.classList.add(RESIZE_PLAID_FRAME_CLASS);
  }
}

export const setPlaidIframeDefaultSize = () => {
  const plaidDom = getPlaidFrame();
  if (!plaidDom) return;
  plaidDom.classList.add(DEFAULT_PLAID_FRAME_CLASS);
}

/**
 * redirect to the first non-null, non-empty, and truthy URL in the list
 * @param  {...any} urls 
 * @returns 
 */
export const redirectToUrl = (...urls) => {
  for (const url of urls) {
    if (url?.trim()) {
      window.location.href = url;
      return;
    }
  }
}
export const replaceEvent = (url, oldEvent, newEvent) => {
  return url.replace('&_eventId=' + oldEvent,'&_eventId=' + newEvent);
}

/**
 * true when the URL points at the IBT consumer (verifiedach.com or any of its sub-domains).
 * Matching on the parsed hostname rather than a regex keeps it correct for every environment
 * (qa2., api.dev., api-stg., ...) and prevents a look-alike host from matching.
 * @param {string} url
 * @returns {boolean}
 */
export const isIbtReturnUrl = (url) => {
  try {
    const { protocol, hostname } = new URL(url);
    return protocol === 'https:' &&
      (hostname === 'verifiedach.com' || hostname.endsWith('.verifiedach.com'));
  } catch {
    return false;
  }
}

const extractLanguageCode = (inputString) => {
  const match = inputString.match(/^[a-zA-Z]{1,8}(?=-|$)/);
  return match ? match[0] : null;
}

export const getDeviceInfo = (client) => {
  const result = {
      userAgent: `${client.getUserAgentLowerCase()}`,
      engine: {
          engine: client.getEngine(),
          engineVersion: client.getEngineVersion(),
      },
      osMethods:{
          os: client.getOS(),
          osVersion: client.getOSVersion(),
          isWindow: client.isWindows(),
          isMac: client.isMac(),
          isLinux: client.isLinux(),
          isUbuntu: client.isUbuntu(),
          isSolaris: client.isSolaris(),
      },
      device:{
          device: client.getDevice(),
          deviceType: client.getDeviceType(),
          deviceVendor: client.getDeviceVendor(),
      },
      cpu: `${client.getCPU()}`,
      mobile: {
          isMobile: client.isMobile(),
          isMobileMajor: client.isMobileMajor(),
          isMobileAndroid: client.isMobileAndroid(),
          isMobileOpera: client.isMobileOpera(),
          isMobileBlackBerry: client.isMobileBlackBerry(),
      },
      mimtype: {
          isMimeTypes: client.isMimeTypes(),
          mimeTypes: client.getMimeTypes()
      },
      fonts: client.getFonts(),
      storage:{
          isLocalStorage: client.isLocalStorage(),
          isSessionStorage: client.isSessionStorage(),
          isCookie: client.isCookie(),
      },
      timezone: client.getTimeZone(),
      systemLanguage: extractLanguageCode(client.getSystemLanguage()),
      screenPrint: client.getScreenPrint(),
      browser:{
          name: client.getBrowser(),
          browserMajorVersion: client.getBrowserMajorVersion()
      },
      canvas: client.getCanvasPrint()
  };
  const primaryIdentityKeys = [
      result.osMethods?.os,
      result.timezone,
      result.systemLanguage,
      result.storage?.isCookie,
      result.mobile?.isMobile,
      result.device?.deviceType,
      result.screenPrint,
      result.canvas,
  ];
  const secondaryIdentityKeys = [
      result.osMethods?.os,
      result.timezone,
      result.systemLanguage,
      result.mobile?.isMobile,
      result.device?.deviceType,
  ];

  const resp =  {
      primaryDeviceId: client.getCustomFingerprint(primaryIdentityKeys.join(" ")),
      secondaryDeviceId: client.getCustomFingerprint(secondaryIdentityKeys.join(" ")),
      metadata: result
  };
  return resp;
}

export const getTraceId = () => {
  const { params } = parseURL(window.location.href);
  const { trace_id: traceId } = params;
  return traceId || getTraceParent();
}

export const getPlaidNuveiLogo = (theme) => {
  const themeName = theme.name || theme.palette.mode || 'light';
  return plaidNuveiLogoMap[themeName];
};